import React, { useState } from "react";
import { Button, Card, Col, Container, Form, Nav, Row } from "react-bootstrap";
import apiClient from "../utils/config/apiClient";
import { Link } from "react-router-dom";

import pageSvg from "../assets/svg/mailbox.svg";
import axios from "axios";
import { toast } from "sonner";

export default function VerifyAccount() {
  document.body.classList.remove("sidebar-show");

  const [otp, setOtp] = useState(new Array(6).fill(""));
  

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return;

    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    // Move to next input if value is entered
    if (element.nextSibling && element.value) {
      element.nextSibling.focus();
    }
  };

  const handleSubmit = (e) => {
    const email = localStorage.getItem("localEmail")
    e.preventDefault();
    const enteredOtp = otp.join("");
    // console.log("Submitted OTP:", enteredOtp);
    try {
      apiClient.post(`public/portal?url=auth/validate/otp`, { "userInput": enteredOtp, "email": email })
        .then((response) => {
          if (response.data.success === true) {
            localStorage.setItem("token", response?.data?.token);
            localStorage.setItem("user", JSON.stringify(response?.data));
            window.location.href = `/pages/newpassword?token=${response?.data?.token}`;
          } else {
            // alert("Invalid OTP");
            toast.error("Invalid OTP");
          }
        })
        .catch((error) => {
          console.error("Error verifying OTP:", error);
          // alert("Error verifying OTP");
        });

    } catch (error) {
      
    }
  };

  return (
    <div className="page-auth">
      <div className="header">
        <Container>
          <Link to="/" className="header-logo">Deda</Link>
          <Nav className="nav-icon">
            <Nav.Link href=""><i className="ri-twitter-fill"></i></Nav.Link>
            <Nav.Link href=""><i className="ri-github-fill"></i></Nav.Link>
            <Nav.Link href=""><i className="ri-dribbble-line"></i></Nav.Link>
          </Nav>
        </Container>
      </div>

      <div className="content">
        <Container>
          <Card className="card-auth">
            <Card.Body className="text-center">
              <div className="mb-5">
                <object type="image/svg+xml" data={pageSvg} className="w-50" aria-label="svg image"></object>
              </div>
              <Card.Title>Enter OTP</Card.Title>
              <Card.Text className="mb-4">We've sent a 6-digit OTP to your email. Enter it below to verify your account.</Card.Text>

              <Form onSubmit={handleSubmit}>
                <div className="d-flex justify-content-center gap-2 mb-4">
                  {otp.map((value, index) => (
                    <Form.Control
                      key={index}
                      type="text"
                      maxLength="1"
                      value={value}
                      onChange={(e) => handleChange(e.target, index)}
                      className="text-center"
                      style={{ width: "50px", height: "50px", fontSize: "20px" }}
                    />
                  ))}
                </div>
                <Button type="submit" variant="primary" className="mb-4 w-100">Verify Account</Button>
              </Form>

              {/* <Row className="g-2 g-sm-3">
                <Col sm><Button variant="outline-primary" onClick={() => alert("Resending OTP...")}>Resend OTP</Button></Col>
                <Col sm><Button variant="secondary">Contact Support</Button></Col>
              </Row> */}
            </Card.Body>
          </Card>
        </Container>
      </div>
    </div>
  );
}
